import { gPaths } from 'views/AppLocals/configs'
import ExaminationContext from 'views/AppLocals/Exam/ExaminationContext'
import createSettingContent from 'views/AppLocals/factory/createSettingContent'

const ExaminationSettingsContent = ({ Wrapper, routes }) => {
  const rootPath = gPaths.examinationSettings
  return createSettingContent(ExaminationContext, {
    routes,
    Wrapper,
    rootPath,
  })
}

export default ExaminationSettingsContent
